import "./Home_Styles/Wellness_Essentials_of_the_Week.css";

const Wellness_Essentials_of_the_Week = () => {
    return (
        <div>
            <p className="Wellness_Essentials_of_the_Week_container-p">Wellness Essentials of the Week</p>
            <p className="Wellness_Essentials_of_the_Week_container-p2">Super charge your immunity with us</p>
            <div className="Wellness_Essentials_of_the_Week_container">
                <div className="Wellness_Essentials_of_the_Week_container_Item">
                    <div>
                        <img src="https://cdn01.pharmeasy.in/dam/products_otc/227623/sevenseas-original-capsule-100s-1-1664874329.jpg?dim=1440x0" alt="" />
                    </div>
                    <div>
                        <p>Sevenseas Original Capsule 100`s</p>
                        <p>MRP <span>₹319.10</span></p>
                        <p>₹255.28 <span>20%OFF</span></p>
                    </div>
                </div>

                <div className="Wellness_Essentials_of_the_Week_container_Item">
                    <div>
                        <img src="https://cdn01.pharmeasy.in/dam/products_otc/O31911/everherb-by-pharmeasy-ashwagandha-immunity-booster-capsules-anxiety-stress-relief-bottle-of-60-2-1661760071.jpg?dim=1440x0" alt="" />
                    </div>
                    <div>
                        <p>Everherb (by Pharmeasy) Ashwagandha...</p>
                        <p>MRP <span>₹599.00</span></p>
                        <p>₹341.43 <span>43%OFF</span></p>
                    </div>
                </div>

                <div className="Wellness_Essentials_of_the_Week_container_Item">
                    <div>
                        <img src="https://cdn01.pharmeasy.in/dam/products_otc/E85132/liveasy-wellness-vitamin-c-990mg-with-zinc-10mg-powerful-immunity-booster-60-veg-tablets-2-1661760130.jpg?dim=1440x0" alt="" />
                    </div>
                    <div>
                        <p>Liveasy Wellness Vitamin C (990mg) With Zinc...</p>
                        <p>MRP <span>₹799.00</span></p>
                        <p>₹599.25<span>25%OFF</span></p>
                    </div>
                </div>

                <div className="Wellness_Essentials_of_the_Week_container_Item">
                    <div>
                        <img src="https://cdn01.pharmeasy.in/dam/products_otc/I40046/vicks-inhaler-keychain-pack-of-1-2-1654166287.jpg?dim=1440x0" alt="" />
                    </div>
                    <div>
                        <p>Vicks Inhaler Keychain Pack Of 1</p>
                        <p>MRP <span>₹62.00</span></p>
                        <p>₹61.38<span>1%OFF</span></p>
                    </div>
                </div>

                <div className="Wellness_Essentials_of_the_Week_container_Item">
                    <div>
                        <img src="https://cdn01.pharmeasy.in/dam/products_otc/I47500/hansaplast-spot-bandage-jar-of-50-2-1654251113.jpg?dim=1440x0" alt="" />
                    </div>
                    <div>
                        <p>Hansaplast Spot Bandage Jar Of 50</p>
                        <p>MRP <span>₹100.00</span></p>
                        <p>₹73.00 <span>27%OFF</span></p>
                    </div>
                </div>

                <div className="Wellness_Essentials_of_the_Week_container_Item">
                    <div>
                        <img src="https://cdn01.pharmeasy.in/dam/products_otc/U97974/everherb-giloy-tulsi-juice-strengthens-body-defence-system-natural-immunity-booster-1-litre-2-1654233486.jpg?dim=1440x0" alt="" />
                    </div>
                    <div>
                        <p>Everherb Giloy Tulsi Juice - Strengthens...</p>
                        <p>MRP <span>₹399.00</span></p>
                        <p>₹199.50 <span>50%OFF</span></p>
                    </div>
                </div>


            </div>
        </div>
    );
};

export {Wellness_Essentials_of_the_Week};